import React, {Component, Fragment} from 'react';
import {FormFeedback, FormGroup, Input, Label} from 'reactstrap';
import defaultPropertiesUpdateFn from '../../models/form/defaultPropertiesUpdateFn';
import LoadingButton from '../../../shared/ui/LoadingButton';
import textValidationFn from '../../models/form/validation/text';
import ValidatingTextInput from '../../../shared/components/form/ValidatingTextInput';
import ValidatingTextarea from '../../../shared/components/form/ValidatingTextarea';
import {connect} from 'react-redux';
import optionsActionCreators from "../../store/options/action-creators";

class TaskGroupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTouched: false,
      properties: {
        description: {
          isValid: true,
          name: 'description',
          value: props.initialValues ? props.initialValues.description : '',
        },
        name: {
          isValid: !!props.initialValues,
          name: 'name',
          value: props.initialValues ? props.initialValues.name : '',
        },
        submitter: {
          isValid: !!(props.initialValues && props.initialValues.flow),
          name: 'submitter',
          value: props.initialValues && props.initialValues.flow ? props.initialValues.flow.submitter : '',
        },
        acknowledger: {
          isValid: true,
          name: 'acknowledger',
          value: props.initialValues && props.initialValues.flow ? props.initialValues.flow.acknowledger : '',
        }
      },
      cssValidationClasses: {
        submitter: '',
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get rolesOptionsTranslated() {
    if (this.props.rolesOptions && this.props.settings) {
      return this.props.rolesOptions.reduce((acc, role) => {
        const roleName = this.props.settings.rolesSettings && this.props.settings.rolesSettings[role.scope];
        return [
          ...acc,
          {
            ...role,
            name: roleName ? roleName : role.name
          }
        ];

      }, []);
    }
  }

  // ----------------------
  // Computed
  // ----------------------

  get isFormValid() {
    return (
      this.state.isTouched &&
      !Object.keys(this.state.properties).find((key) => {
        return !this.state.properties[key].isValid;
      })
    );
  }

  componentDidMount() {
    this.props.fetchOptions('roles');
  }

  // ----------------------
  // Methods
  // ----------------------

  handleChange(valueObject) {
    const callback = () => {
      if (!this.state.isTouched) {
        this.setState({isTouched: true});
      }
    };
    this.setState(
      defaultPropertiesUpdateFn(valueObject.name, valueObject),
      callback,
    );
  }

  handleInput(event) {
    const {name, value} = event.target;
    const valueObject = {
      isValid: name == 'submitter' ? value != '' : true,
      name: name,
      value: value
    };
    const callback = () => {
      if (!this.state.isTouched) {
        this.setState({isTouched: true});
      }
    };
    this.setState(
      defaultPropertiesUpdateFn(name, valueObject),
      callback,
    );

    if (name == 'submitter') {
      this.setState({
        cssValidationClasses: {
          'submitter': !valueObject.isValid ? 'is-invalid' : 'is-valid'
        }
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const properties = {
      description: this.state.properties.description.value,
      name: this.state.properties.name.value.trim(),
      flow: {
        'submitter': this.state.properties.submitter.value,
        'acknowledger': this.state.properties.acknowledger.value ? this.state.properties.acknowledger.value : null
      }
    };
    this.props.onSave(properties);
  }

  getTranslated(role) {
    try {
      return this.rolesOptionsTranslated.find(r => r.scope === role).name
    } catch (ex) {
      return role
    }
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <div className="app-content">
          <Fragment>
            <form noValidate onSubmit={this.handleSubmit}>
              <ValidatingTextarea
                initialValue={
                  this.props.initialValues ? this.props.initialValues.name : ''
                }
                label="Name"
                onChange={this.handleChange}
                name="name"
                required
                validationFn={textValidationFn('Name', true)}
                value={this.state.properties.name.value}
              />
              <ValidatingTextarea
                initialValue={
                  this.props.initialValues
                    ? this.props.initialValues.description
                    : ''
                }
                label="Reference Material"
                onChange={this.handleChange}
                name="description"
                validationFn={() => null}
                value={this.state.properties.description.value}
              />
              <FormGroup>
                <Label for="submitter">Submitter role</Label>
                <Input
                  className={this.state.cssValidationClasses.submitter}
                  id="submitter"
                  name="submitter"
                  onChange={event => this.handleInput(event)}
                  type="select"
                  value={this.state.properties.submitter.value}
                >
                  <option defaultValue value=""/>
                  <option value="oit">{this.getTranslated('oit')}</option>
                  <option value="fto">{this.getTranslated('fto')}</option>
                </Input>
                <FormFeedback>Submitter role is required</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label for="acknowledger">Acknowledger role</Label>
                <Input
                  id="acknowledger"
                  name="acknowledger"
                  onChange={event => this.handleInput(event)}
                  type="select"
                  value={this.state.properties.acknowledger.value}
                >
                  <option defaultValue value=""/>
                  <option value="oit">{this.getTranslated('oit')}</option>
                  <option value="fto">{this.getTranslated('fto')}</option>
                  <option value="ftoc">{this.getTranslated('ftoc')}</option>
                </Input>
              </FormGroup>
              <div className="text-right">
                <LoadingButton
                  disabled={!this.isFormValid}
                  isLoading={this.props.isLoading}
                  primary
                  text="Submit"
                />
              </div>
            </form>
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    rolesOptions: state.options.roles,
    settings: state.departmentSettings.settings
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchOptions: (apiKey) => {
      return dispatch(optionsActionCreators.fetchOptions(apiKey))
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(TaskGroupForm);
